import { Component, OnInit, ViewChild, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';

import {
  FiltersService
} from '../../services';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.scss']
})
export class StoresComponent implements OnInit, OnChanges {
  @Output() stores = new EventEmitter();

  @Input() provider;
  @Input() selectedStores = [];

  @ViewChild('autocompleteStores', { static: true }) autocompleteStores;

  autocompleteDataStores;

  placeHolder = "Pesquisar";
  notFoundText = "Sem resultados";

  searchKeywordStore = "nmFantasia";

  constructor( private filtersService: FiltersService ) { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes.provider) {
      if (!changes.provider.firstChange) {
        this.listStores(changes.provider.currentValue);
      }
    }
  }

  listStores(id) {
    this.autocompleteDataStores = [];

    this.filtersService.listStores(`?cdFornecedor=${id}&flAreaAtuacao=1`).subscribe((response) => {
      this.autocompleteDataStores = response['data'];

      this.autocompleteDataStores = _.orderBy(this.autocompleteDataStores, 'nmFantasia');
    });
  }

  onSelectStores(item) {
    this.selectedStores.push(item);

    this.selectedStores = _.uniqBy(this.selectedStores, 'nmFantasia');

    this.autocompleteStores.query = "";

    this.stores.emit(this.selectedStores);
  }

  deleteSelectStores(item) {
    _.remove(this.selectedStores, function(n) {
      return n.nmFantasia == item.nmFantasia;
    });
  }

}
